import React from 'react';
import { Countdown } from './Countdown';
import { CheckCircle2, ShieldCheck, Gift, Calculator } from 'lucide-react';
export function PurchaseSection() {
  const includes = ['6 Capítulos completos', '3 Bonos gratis', 'Acceso inmediato', 'PDF descargable', 'Actualizaciones gratuitas', 'Garantía 7 días'];
  return <section id="comprar" className="py-16 md:py-24 px-4 bg-darker border-t border-orange-500/30 relative overflow-hidden" data-id="element-88">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-orange-500/10 rounded-full blur-[100px] pointer-events-none" data-id="element-89"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-90">
        <div className="bg-orange-500 text-white text-center py-2 px-4 rounded-t-xl font-bold uppercase tracking-wider text-sm md:text-base" data-id="element-91">
          OFERTA TERMINA EN:
        </div>

        <div className="bg-card border border-gray-800 rounded-b-xl p-6 md:p-10 shadow-2xl" data-id="element-92">
          <div className="mb-8" data-id="element-93">
            <Countdown data-id="element-94" />
          </div>

          <h2 className="text-4xl md:text-6xl font-bebas text-center mb-8" data-id="element-95">
            ACCEDÉ HOY A{' '}
            <span className="text-orange-500" data-id="element-96">ESCALADA PRO SYSTEM</span>
          </h2>

          <div className="flex flex-col md:flex-row gap-8 items-center justify-center mb-10" data-id="element-97">
            <div className="w-full md:w-1/2 max-w-[300px]" data-id="element-98">
              <a href="https://checkout.ebookbtnlines.shop/cart/45380998987823:1" className="block transform hover:scale-105 transition-transform" data-id="element-99">
                <img src="https://cdn.magicpatterns.com/uploads/mGQqY8Pjy1f7dwLDGoVr5E/ChatGPT_Image_May_16,_2026,_11_39_22_PM.png" alt="Escalada Pro System" className="w-full h-auto rounded-lg shadow-lg shadow-orange-500/20" data-id="element-100" />
              </a>
            </div>

            <div className="w-full md:w-1/2 flex flex-col items-center md:items-start" data-id="element-101">
              <div className="flex items-center gap-3 mb-2" data-id="element-102">
                <span className="text-gray-500 line-through text-xl md:text-2xl font-bold" data-id="element-103">
                  $49.990
                </span>
                <span className="bg-orange-500/20 text-orange-500 px-2 py-1 rounded text-sm font-bold" data-id="element-104">
                  60% OFF
                </span>
              </div>
              <div className="text-5xl md:text-7xl font-bebas text-orange-500 mb-6" data-id="element-105">
                $19.990 <span className="text-2xl text-gray-400" data-id="element-106">ARS</span>
              </div>

              <ul className="space-y-3 mb-6 w-full" data-id="element-107">
                {includes.map((item, idx) => <li key={idx} className="flex items-center text-gray-300" data-id="element-108">
                    <CheckCircle2 className="w-5 h-5 text-orange-500 mr-3 flex-shrink-0" data-id="element-109" />
                    <span data-id="element-110">{item}</span>
                  </li>)}
              </ul>

              <div className="w-full bg-orange-500/10 border-2 border-dashed border-orange-500 rounded-xl p-4 flex items-center gap-3" data-id="element-111">
                <div className="bg-orange-500/20 p-2 rounded-lg flex-shrink-0" data-id="element-112">
                  <Calculator className="w-6 h-6 text-orange-500" data-id="element-113" />
                </div>
                <div data-id="element-114">
                  <div className="flex items-center gap-2 mb-1" data-id="element-115">
                    <Gift className="w-4 h-4 text-orange-500" data-id="element-116" />
                    <span className="text-xs font-bold text-orange-500 uppercase tracking-wider" data-id="element-117">
                      Regalo extra hoy
                    </span>
                  </div>
                  <p className="text-sm text-white font-medium leading-tight" data-id="element-118">
                    Comprando hoy llevate <strong data-id="element-119">sin cargo</strong> una
                    calculadora de proteínas e hidratación.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center" data-id="element-120">
            <a href="https://checkout.ebookbtnlines.shop/cart/45380998987823:1" className="inline-flex items-center justify-center w-full md:w-auto bg-orange-500 hover:bg-orange-600 text-white font-bold text-2xl py-6 px-12 rounded-xl shadow-[0_0_40px_rgba(249,115,22,0.5)] transition-all transform hover:scale-105 active:scale-95 animate-pulse hover:animate-none" data-id="element-121">
              <span className="mr-3" data-id="element-122">🧗</span> QUIERO COMPRAR AHORA
            </a>

            <div className="mt-6 flex flex-col items-center gap-2" data-id="element-123">
              <div className="flex gap-4 text-gray-400 text-sm font-medium" data-id="element-124">
                <span data-id="element-125">Mercado Pago</span>
                <span data-id="element-126">•</span>
                <span data-id="element-127">Visa</span>
                <span data-id="element-128">•</span>
                <span data-id="element-129">Mastercard</span>
              </div>
              <div className="flex items-center gap-2 text-gray-500 text-sm mt-2" data-id="element-130">
                <ShieldCheck className="w-4 h-4" data-id="element-131" />
                <span data-id="element-132">Garantía de devolución 7 días sin preguntas</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}